import React from "react";
import { useUserContext } from "context/UserContext";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";
import BillingReconcileCM from "layouts/CM/billingReconcile";

function BillingReconcile() {
  const { roleLevel } = useUserContext() || {};
  if (isManagementRoleLevel(normalizeRoleLevel(roleLevel))) {
    return <BillingReconcileCM />;
  }
  return null;
}

export default BillingReconcile;
